<template>
  <el-table-column width="45px" align="center">
    <template slot-scope="{row,$index}">
      <el-dropdown
        class="no-focus"
        trigger="click"
        placement="bottom"
        @command="onInsert($event,$index)"
      >
        <el-button type="text" style="font-size: 14px;" icon="el-icon-s-tools"></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="up">向上插入一行</el-dropdown-item>
          <el-dropdown-item command="down">向下插入一行</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </el-table-column>
</template>
<script>
export default {
  methods: {
    onInsert(type, index) {
      this.$emit("on-insert", { type, index });
    },
  },
};
</script>